import { render, staticRenderFns } from "./MOT.vue?vue&type=template&id=4dd81606&"
import script from "./MOT.vue?vue&type=script&lang=js&"
export * from "./MOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports